import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect } from 'react';
function useWindowScrollListener(t0) {
  "use memo";

  const $ = _c(7);
  const {
    listenToScroll,
    onScroll,
    useCapture
  } = t0;
  let t1;
  if ($[0] !== onScroll) {
    t1 = () => {
      requestAnimationFrame(() => onScroll());
    };
    $[0] = onScroll;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOnScroll = t1;
  let t2;
  let t3;
  if ($[2] !== handleOnScroll || $[3] !== listenToScroll || $[4] !== useCapture) {
    t2 = () => {
      if (!listenToScroll) {
        return () => {
          window.removeEventListener("scroll", handleOnScroll, useCapture);
        };
      }
      window.addEventListener("scroll", handleOnScroll, useCapture);
      return () => {
        window.removeEventListener("scroll", handleOnScroll, useCapture);
      };
    };
    t3 = [listenToScroll, handleOnScroll, useCapture];
    $[2] = handleOnScroll;
    $[3] = listenToScroll;
    $[4] = useCapture;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
}
export default useWindowScrollListener;